import { DeviceWithVehicleInfo } from "@/models/DeviceWithVehicleInfo";

/**
 * The firmware a telematics unit is running, as one string.
 *
 * Only built when every part is known: a half-built version string reads like a real one, and
 * both places that show it are places someone signs a vehicle off from.
 *
 * @param device - The device. Note that MyGeotab only returns these fields when they were asked
 *   for explicitly, so a device fetched with a narrow property selector reports nothing here.
 */
export function getFirmwareValue(device: DeviceWithVehicleInfo | null | undefined): string {
  if (!device) {
    return "";
  }

  const { productId, major, minor, parameterVersion, parameterVersionOnDevice } = device;
  const parts = [productId, major, minor, parameterVersion, parameterVersionOnDevice];
  if (parts.some(part => part == null)) {
    return "";
  }

  return `${productId}.${major}.${minor} param ${parameterVersion} paramOnDevice ${parameterVersionOnDevice}`;
}
